import { downloadFileFromAssetsDirectly } from '@dealstack/frontend/shared/files/downloadFile';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Box, Button, Group, List, Stack, Text } from '@mantine/core';

interface Props {
	instruction: string;
	fileName: string;
}

export const RequirementsInstructionsComponent = (props: Props) => {
	const tInvestor = useTranslationInvestor();

	const { instruction, fileName } = props;

	return (
		<Box
			style={{
				gap: '0.5rem',
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
				width: '100%',
			}}
		>
			<Box>
				<Group grow gap="sm" style={{ marginBottom: '1rem' }}>
					<Button
						variant="secondary"
						style={{ width: '100%' }}
						onClick={() => downloadFileFromAssetsDirectly(instruction, fileName)}
					>
						{tInvestor(
							'valuations.drawer.what_do_i_need.buttons.download_instructions'
						)}
					</Button>
				</Group>

				<Box
					sx={(theme) => ({
						borderRadius: '0.25rem',
						border: `1px solid ${theme.colors.gray[2]}`,
						background: `${theme.colors.gray[0]}`,
						padding: '0.5rem',
					})}
				>
					<Text size="B5Bold">
						{tInvestor('valuations.drawer.what_do_i_need.checklist.title')}
					</Text>
					<Text size="B6Bold" style={{ marginTop: '0.25rem' }}>
						{tInvestor('valuations.drawer.what_do_i_need.checklist.desc')}
					</Text>
					<Stack gap="sm" mt="1rem">
						<List listStyleType="disc" spacing="1rem" style={{ overflow: 'hidden' }}>
							{[1, 2, 3, 4].map((item) => (
								<List.Item key={item} style={{ maxWidth: 'calc(100% - 20px)' }}>
									{tInvestor(
										`valuations.drawer.what_do_i_need.checklist.steps.${item.toString()}`
									)}
								</List.Item>
							))}
						</List>
					</Stack>
				</Box>
			</Box>
		</Box>
	);
};
